import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const obtenerListadoColaboradores = async ({ token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.COLLABORATORS}`, extraHeaders: { token: token } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default obtenerListadoColaboradores;